import React from 'react';
import { Box, IconButton } from '@mui/material';
import { DEEP_GREEN } from '../colorTokens';

// Icon-only action buttons (refresh / download): white fill with a thin border so they stay visible,
// and an explicit keyboard focus ring.
const ICON_BUTTON_SX = {
  bgcolor: '#fff',
  color: DEEP_GREEN,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  '&:hover': { bgcolor: '#fff', filter: 'brightness(0.92)' },
  '&.Mui-focusVisible': { outline: `2px solid ${DEEP_GREEN}`, outlineOffset: 2 },
  '&.Mui-disabled': { bgcolor: '#fff', opacity: 0.5 }
};

// Icon-only button with a CSS-positioned tooltip centred above it. MUI's <Tooltip> (Popper) can't be
// used here: the app runs under `body { zoom: 0.8 }` (main.css), which throws off Popper's measured
// positioning. The wrapper span also keeps hover/focus working while the button is disabled.
// The label is aria-hidden because the button's aria-label already names it for assistive tech.
const ICON_TIP_WRAPPER_SX = {
  position: 'relative',
  display: 'inline-flex',
  '& .icon-tip': {
    position: 'absolute',
    bottom: 'calc(100% + 6px)',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    bgcolor: 'rgba(33, 33, 33, 0.92)',
    color: '#fff',
    fontSize: '0.75rem',
    lineHeight: 1.4,
    px: 1,
    py: 0.5,
    borderRadius: 1,
    pointerEvents: 'none',
    zIndex: 1500,
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 0.15s'
  },
  '&:hover .icon-tip, &:focus-within .icon-tip': { visibility: 'visible', opacity: 1 }
};

export function IconActionButton({ label, icon, ...buttonProps }) {
  return (
    <Box component="span" sx={ICON_TIP_WRAPPER_SX}>
      <IconButton aria-label={label} size="small" sx={ICON_BUTTON_SX} {...buttonProps}>
        {icon}
      </IconButton>
      <Box component="span" className="icon-tip" aria-hidden="true">{label}</Box>
    </Box>
  );
}
